const plugins = require('../utils/plugins');

plugins.createTab({
  triggers: '.tab-box-option',
  elements: '.tab-box-item'
});